import { sbMsgBus } from "../../mbus";
/* istanbul ignore next */
export const GeoTopics = {
    SB_GeoOnLogin: sbMsgBus.sbPrefix + "geo_sdk_login",
    SB_GeoOnLogout: sbMsgBus.sbPrefix + "geo_sdk_logout",
    SB_HideRegulationMessageonUserLogin: sbMsgBus.sbPrefix + "hideRegulationMessageonUserLogin",
    SB_ShowRegulationMessageonUserLogin: sbMsgBus.sbPrefix + "showRegulationMessageonUserLogin",
    SB_HideHeaderLoader: sbMsgBus.sbPrefix + "hideHeaderLoader",
    SB_GeoSdkTopic: sbMsgBus.sbPrefix + "geo_sdk_topic",
    SB_GeoPlaceBetTopic: sbMsgBus.sbPrefix + "geo_sdk_place_bet_topic",
    SB_GeoCashoutTopic: sbMsgBus.sbPrefix + "geo_sdk_cashout_topic"
}
